module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/fb-orange-9874fb6b02dd37278282793d8b915845.svg";